import styled from 'styled-components/macro'

const Button = styled.button`
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  text-align: center;
  letter-spacing: 0.25px;

  border-radius: 8px;
  border-width: 0;

  &:disabled {
    opacity: 0.4;
  }
`

export const PrimaryButton = styled(Button)`
  color: #283257;
  background: #6ad5e5;
`

export const TernaryButton = styled(Button)`
  color: #ffffff;
  background: #eb4860;
`

export const ButtonSC = styled.button<{ btnColor: string }>`
  flex: 1;
  margin-left: 20px;
  text-transform: uppercase;
  background-color: ${(props) => props.btnColor};
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  font-weight: 800;
  font-size: 14px;
  padding: 13px;
  position: relative;
  outline: none;

  & span:nth-of-type(1) {
    position: absolute;
    left: 20px;
  }
`
